import $ from "jquery";

export class showMoreLess {
    constructor(config) {
        if(config.maxHeight === "" || config.maxHeight === 'null') {
            config.maxHeight = 130;
        }
        this.init(config);
    }

    init(config) {
        const buttonShow = $(window.document).find('#' + config.buttonNameShow);
        const buttonHide = $(window.document).find('#' + config.buttonNameHide);
        const classHide = 'do-not-show';
        const topElement = '.show-hide-section';
        $(buttonHide).addClass('hide-button');
        buttonShow.parent().find(topElement).css({"maxHeight": config.maxHeight + "px"});
        buttonShow.parent().find(topElement).addClass(classHide);
        $(buttonShow).on('click', function(e) {
            let hideSection = $(e.currentTarget.parentElement).find(topElement);
            hideSection.removeClass(classHide);
            hideSection.css({"maxHeight": "none"});
            if(!(config.readLessDeclared === "" || config.readLessDeclared === 'null')) {
                $(buttonShow).addClass('hide-button');
                $(buttonHide).removeClass('hide-button');
            } else {
                $(buttonShow).addClass('no-hide-button');
            }
        });

        $(buttonHide).on('click', function(e) {
            let hideSection = $(e.currentTarget.parentElement).find(topElement);
            $(buttonHide).addClass('hide-button');
            $(buttonShow).removeClass('hide-button');
            hideSection.addClass(classHide);
            hideSection.css({"maxHeight": config.maxHeight + "px"});
        });
    }
}

export let startShowMoreLess = (config) => new showMoreLess(config);
